'use client'

import { useUserStore } from '@utsubo/experience'
import dynamic from 'next/dynamic'

const WorkspacesList = dynamic(
  () => import('@utsubo/ui').then((mod) => mod.WorkspacesList),
  {
    ssr: false,
  }
)

export const RootUiWrapper = () => {
  const user = useUserStore((s) => s.user)
  return user?.email ? (
    <WorkspacesList />
  ) : (
    <a
      style={{
        pointerEvents: 'all',
        textDecoration: 'underline',
      }}
      href='/login'
    >
      Login
    </a>
  )
}
